import { Reveal } from "./Reveal";
import { SERVICES } from "../lib/site";
import { Check, ArrowUpRight } from "lucide-react";

export default function ServicesGrid() {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="bg-slate-50 py-20 lg:py-32"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
                <Reveal className="mb-14 max-w-2xl">
                    <span className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-brand">
                        What We Do
                    </span>
                    <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-navy sm:text-4xl">
                        End-to-end technology solutions for real-world needs.
                    </h2>
                    <p className="mt-4 text-base leading-relaxed text-slate-600">
                        From first deployment to ongoing support, we help clients
                        select, build, connect, and maintain the technology they
                        depend on.
                    </p>
                </Reveal>

                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                    {SERVICES.map((s, i) => (
                        <Reveal key={s.key} delay={(i % 3) * 0.08}>
                            <article
                                data-testid={s.testid}
                                className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-brand/40 hover:shadow-[0_24px_50px_rgba(2,132,199,0.14)]"
                            >
                                <div
                                    className="pointer-events-none absolute inset-x-0 -top-24 h-24 bg-gradient-to-b from-brand/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                                    aria-hidden="true"
                                />
                                <div className="mb-5 flex items-center justify-between">
                                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand-50 text-brand transition-colors group-hover:bg-brand group-hover:text-white">
                                        <s.icon className="h-6 w-6" />
                                    </span>
                                    <ArrowUpRight className="h-5 w-5 text-slate-300 transition-colors group-hover:text-brand" />
                                </div>

                                <h3 className="font-display text-xl font-semibold leading-snug text-navy">
                                    {s.title}
                                </h3>
                                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                                    {s.blurb}
                                </p>

                                <ul className="mt-5 space-y-2 border-t border-slate-100 pt-5">
                                    {s.points.map((p) => (
                                        <li
                                            key={p}
                                            className="flex items-start gap-2 text-xs leading-relaxed text-slate-600"
                                        >
                                            <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand" />
                                            <span>{p}</span>
                                        </li>
                                    ))}
                                </ul>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
